import * as service from './service'
export default {
  namespace: 'customerServiceComplainsRecords',
  state: {},
  effects: {
    * pagingUserTickets ({ payload }, { call, put }) {
      const res = yield call(service.pagingUserTickets, payload)
      return res.data
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
